import { registerExperiment } from '@xingternal/splitkit';

export const REGISTER_VIA_CV_EXPERIMENT = {
  name: 'ABACUS-177',
  trackingId: 'A-177',
  supportedVariants: ['A', 'B'],
  isLoggedOut: true,
};
export const LEBENSLAUF_EXPERIMENT_NAME = {
  name: 'ABACUS-62',
  trackingId: 'A-62',
  supportedVariants: ['A', 'B'],
  isLoggedOut: true,
};
export const JOBSEEKER_EXPERIMENT_NAME = {
  name: 'ABACUS-95',
  trackingId: 'A-95',
  supportedVariants: ['A', 'B'],
  isLoggedOut: true,
};
export const LOSP_MARKETING_CAMPAIGN_TEST = {
  name: 'ABACUS-219',
  trackingId: 'A-219',
  supportedVariants: ['A', 'B', 'C'],
  isLoggedOut: true,
};

const register = () => {
  [
    REGISTER_VIA_CV_EXPERIMENT,
    LEBENSLAUF_EXPERIMENT_NAME,
    JOBSEEKER_EXPERIMENT_NAME,
    LOSP_MARKETING_CAMPAIGN_TEST,
  ].forEach(({ name, supportedVariants, isLoggedOut }) => {
    registerExperiment(
      name,
      supportedVariants,
      isLoggedOut ? 'visitor' : undefined
    );
  });
};

export default register;
